import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from './Button';
import Icon from '../AppIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
  { name: 'Command Center', path: '/nexus-command-center-homepage', icon: 'Home' },
  { name: 'Identity Matrix', path: '/identity-matrix-about', icon: 'User' },
  { name: 'Arsenal', path: '/arsenal-showcase-skills-technologies', icon: 'Zap' },
  { name: 'Projects', path: '/project-dimensions-portfolio', icon: 'Layers' }];


  const secondaryItems = [
  { name: 'Contact', path: '/neural-network-contact-collaboration', icon: 'MessageSquare' }];


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-background/95 backdrop-blur-md cyber-border-b' : 'bg-transparent'}`
      }>

      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-6 lg:px-8">
          {/* Logo */}
          <Link
            to="/nexus-command-center-homepage"
            className="flex items-center space-x-3 cyber-hover group"
            onClick={closeMenu}>

            <div className="relative">
              <div className="w-10 h-10 bg-gradient-to-br from-brand-cyan to-brand-purple rounded-lg flex items-center justify-center cyber-glow group-hover:cyber-glow-intense transition-all duration-300">
                <Icon name="Cpu" size={24} color="#ffffff" className="group-hover:scale-110 transition-transform duration-300" />
              </div>
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-brand-green rounded-full animate-pulse"></div>
            </div>
            <div className="hidden sm:block">
              <h1 className="font-orbitron font-bold text-xl text-foreground group-hover:text-brand-cyan transition-colors duration-300">
                CyberDev
              </h1>
              <p className="font-mono text-xs text-text-secondary -mt-1 group-hover:text-brand-green transition-colors duration-300">Lwando Ntlemeza

              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) =>
            <Link
              key={item.path}
              to={item.path}
              className={`relative px-4 py-2 rounded-lg font-inter font-medium text-sm transition-all duration-300 cyber-hover group ${
              isActivePath(item.path) ?
              'text-brand-cyan bg-brand-cyan/10 cyber-border' : 'text-text-secondary hover:text-foreground hover:bg-surface/50'}`
              }>

                <div className="flex items-center space-x-2">
                  <Icon
                  name={item.icon}
                  size={16}
                  className={`transition-colors duration-300 ${
                  isActivePath(item.path) ? 'text-brand-cyan' : 'group-hover:text-brand-cyan'}`
                  } />

                  <span>{item.name}</span>
                </div>
                {isActivePath(item.path) &&
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-brand-cyan rounded-full animate-pulse"></div>
              }
              </Link>
            )}
            
            {/* More Menu */}
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg font-inter font-medium text-sm text-text-secondary hover:text-foreground hover:bg-surface/50 transition-all duration-300 cyber-hover flex items-center space-x-2">
                <Icon name="MoreHorizontal" size={16} className="group-hover:text-brand-cyan transition-colors duration-300" />
                <span>More</span>
              </button>
              
              <div className="absolute top-full right-0 mt-2 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                <div className="glass-morphism rounded-lg p-2 cyber-border">
                  {secondaryItems.map((item) =>
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-all duration-300 cyber-hover ${
                    isActivePath(item.path) ?
                    'text-brand-cyan bg-brand-cyan/10' : 'text-text-secondary hover:text-foreground hover:bg-surface/30'}`
                    }>

                      <Icon name={item.icon} size={16} />
                      <span>{item.name}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              className="cyber-border hover:cyber-border-active hover:cyber-glow transition-all duration-300"
              iconName="Zap"
              iconPosition="left"
              iconSize={16}>

              Enter Matrix
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 rounded-lg text-text-secondary hover:text-foreground hover:bg-surface/50 transition-all duration-300 cyber-hover">

            <Icon name={isMenuOpen ? "X" : "Menu"} size={24} />
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden transition-all duration-300 overflow-hidden ${
        isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`
        }>
          <div className="glass-morphism mx-4 mb-4 rounded-lg cyber-border">
            <nav className="p-4 space-y-2">
              {[...navigationItems, ...secondaryItems].map((item) =>
              <Link
                key={item.path}
                to={item.path}
                onClick={closeMenu}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-inter font-medium text-sm transition-all duration-300 cyber-hover ${
                isActivePath(item.path) ?
                'text-brand-cyan bg-brand-cyan/10 cyber-border' : 'text-text-secondary hover:text-foreground hover:bg-surface/30'}`
                }>

                  <Icon name={item.icon} size={18} />
                  <span>{item.name}</span>
                  {isActivePath(item.path) &&
                <div className="ml-auto w-2 h-2 bg-brand-cyan rounded-full animate-pulse"></div>
                }
                </Link>
              )}
              
              <div className="pt-4 border-t border-border">
                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  className="cyber-border hover:cyber-border-active hover:cyber-glow transition-all duration-300"
                  iconName="Zap"
                  iconPosition="left"
                  iconSize={16}
                  onClick={closeMenu}>
                  Enter Matrix
                </Button>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>);

};

export default Header;